import script from "./About.vue?vue&type=script&setup=true&lang=ts"
export * from "./About.vue?vue&type=script&setup=true&lang=ts"

import "./About.vue?vue&type=style&index=0&id=7c542e7f&lang=css"

const __exports__ = script;

export default __exports__